import { getThreeDsChallengeDisplaySize, renderIframeAndWaitForPostback, } from '../3d-secure';
import { logTaggedMessage } from '../../reporter';
import { getIframeOriginToBeValidatedForWixDomain, threeDsErrors, } from '../3ds-utils';
import { removeChallengeIframe } from '../iframe-handler';
import { MethodType } from '@wix/ambassador-checkout-view-server/types';
const log = logTaggedMessage({
    module: '3ds',
    sub_moodule: 'redirect-action',
});
export const redirectAction = async ({ data: actionData, methodUrl, provider, methodType, }) => {
    const challengeDisplaySize = getThreeDsChallengeDisplaySize();
    const redirectMethod = methodType === MethodType.POST ? 'POST' : 'GET';
    const success = (redirectResultData) => {
        const dataToServer = {
            ...redirectResultData,
            ...actionData,
        };
        return {
            redirectData: {
                provider,
                data: dataToServer,
                received: {},
            },
        };
    };
    const fail = (error) => {
        return {
            redirectData: {
                provider,
                data: actionData,
                notReceived: { error },
            },
        };
    };
    const logData = {
        actionData,
        methodUrl,
        provider,
        challengeDisplaySize,
    };
    log('3ds: before render 3ds redirect iframe', logData);
    if (!methodUrl) {
        const ret = fail(threeDsErrors.missingUrl(provider.providerType, 'redirect'));
        log(`3ds: ${provider} redirect action failed`, { ...logData, ret });
        return ret;
    }
    const resultPromise = renderIframeAndWaitForPostback('visible', methodUrl, redirectMethod, actionData, getIframeOriginToBeValidatedForWixDomain());
    try {
        const redirectResult = await resultPromise;
        if (!redirectResult) {
            const err = `Redirect Action Error!
      recived: ${redirectResult}`;
            const ret = fail(err);
            log(`3ds: ${provider} redirect action failed`, { ...logData, err, ret });
            return ret;
        }
        log('3ds: received redirect success', {
            ...logData,
            redirectResult,
        });
        return success(redirectResult);
    }
    catch (e) {
        const ret = fail(threeDsErrors.generate3dsError({
            providerFlow: 'PAYMENTS',
            step: 'redirect',
            e,
        }));
        log(`3ds: Redirect failed`, { ...logData, ret, e });
        return ret;
    }
    finally {
        removeChallengeIframe();
    }
};
//# sourceMappingURL=redirect-action.js.map